<template>
<div class="col-md-12">
  <div class="card">
    <form>
      <div class="card-header">
        <h4 class="card-title"> Novo Usuário </h4>
      </div>
      <div class="card-content">
        <div class="form-group">
          <label>Nome</label>
          <input
            type="text"
            name="name"
            v-validate="modelValidations.nameField"
            v-model="name"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="nameField.invalid"
          > {{ getError('nameField') }}
          </small>
        </div>
        <div class="form-group">
          <label>Login</label>
          <input
            type="text"
            name="login"
            v-validate="modelValidations.loginField"
            v-model.trim="login"
            class="form-control"
          >
          <small
            class="text-danger"
            v-show="loginField.invalid"
          >
            {{ getError('loginField') }}
          </small>
        </div>

        <div class="form-group">
          <div class="form-group">
            <label>{{ editing ? 'Nova Senha' : 'Senha'}}</label>
            <input
              type="password"
              name="password"
              v-validate="modelValidations.passwordField"
              v-model.trim="password"
              class="form-control"
            >
            <small
              class="text-danger"
              v-show="passwordField.invalid"
            >
              {{ getError('passwordField') }}
            </small>
          </div>
          <div class="form-group">
            <label>{{ editing ? 'Confirmar Nova Senha' : 'Confirmar Senha'}} </label>
            <input
              type="password"
              name="confirm"
              v-model.trim="confirmPassword"
              class="form-control"
            >
          </div>
        </div>

        <div class=" row form-group">
          <div class="col-md-6">
            <label>Função do usuário</label> <br>
            <el-select
              class="select-primary"
              ref="selectRole"
              size="large"
              name="role"
              @change="changingRole"
              v-validate="modelValidations.roleField"
              v-model="roleValue"
            >
              <el-option
                class="select-primary"
                v-for="(item, index) in rolesOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <small
              class="text-danger"
              v-show="roleField.invalid"
            >
              {{ getError('roleField') }}
            </small>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button
          type="submit"
          :disabled="saving"
          @click.prevent="handleSave"
          class="btn btn-fill btn-success btn-wd"
        >Salvar
        </button>
      </div>
    </form>
  </div>
</div>
</template>
<script>
import AuthService from 'src/services/AuthService'
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      saving: false,
      indexPath: { name: 'users.index' },
      roleValue: '',
      rolesOptions: [],
      oldPassword: '',
      confirmOldPassword: '',
      name: '',
      login: '',
      password: '',
      confirmPassword: '',
      role: '',
      inactivated: false
    }
  },
  computed: {
    ...mapFields([
      'nameField',
      'loginField',
      'passwordField',
      'confirmField',
      'roleField'
    ]),
    ...mapGetters('users', {
      user: 'user',
      modelValidations: 'validations',
      loading: 'loading'
    }),
    ...mapGetters('roles', {
      roles: 'roles'
    }),
    id () {
      return this.$route.params.id
    },
    editing () {
      return this.id !== undefined
    }
  },
  methods: {
    ...mapActions('users', ['fetchOne', 'resetOne', 'insert', 'update', 'upsert']),
    ...mapActions('roles', { getRoles: 'fetchAll' }),
    setOptions () {
      this.rolesOptions = []
      for (let r of this.roles) {
        this.rolesOptions.push({
          label: r.label,
          value: r.name
        })
      }
    },

    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    handleSave () {
      this.saving = true

      if (!this.validateForm()) {
        this.saving = false
        return
      }

      const doc = Object.assign({}, this.user, {
        name: this.name,
        login: this.login,
        role: this.role,
        collection: 'users',
        password: this.defineUserPassword()
      })
      if (this.password.trim().length > 0) {
        return AuthService.hash(doc.password)
          .then(result => {
            doc.password = result
            return this.saveUser(doc)
          })
          .catch(err => {
            console.log(err)
            this.saving = false
            return err
          })
      }
      return this.saveUser(doc)
    },

    saveUser (doc) {
      return this.upsert(doc)
        .then((res) => {
          this.notifySaved()
          this.saving = false
          this.$router.push(this.indexPath)
          return res
        })
        .catch(err => {
          console.log(err)
          this.saving = false
          return err
        })
    },

    validateForm () {
      if (this.name.length === 0 || this.name.trim() === '') {
        this.$notify({
          message: 'Nome é obrigatório',
          type: 'danger'
        })
        return false
      }

      if (this.login === '' || this.login.length < 5) {
        this.$notify({
          message: 'Login obrigatório e no mínimo 5 letras',
          type: 'danger'
        })
        return false
      }

      if (!this.validPassword) {
        this.$notify({
          message: 'Senha é inválida. Senha obrigatório e no mínimo 5 letras. A senha deve ser igual a de confirmação',
          type: 'danger'
        })
        return false
      }

      if (this.role === '') {
        this.$notify({
          message: 'Permissão é obrigatória',
          type: 'danger'
        })
        return false
      }

      return true
    },

    validate () {
      return this.$validator.validateAll()
    },

    defineUserPassword () {
      return this.password.trim().length > 0 && this.canChangePassword() ? this.password : this.user.password
    },

    notifyPasswordWrong () {
      this.saving = false
      this.$notify({
        message: 'Senha não estão iguais.',
        type: 'warning'
      })
      return false
    },

    notifySaved () {
      this.$notify({
        message: 'Usuário salvo com sucesso',
        type: 'success'
      })
    },

    changingRole () {
      this.role = this.roleValue
    },

    setOldValues () {
      this.name = this.user.name
      this.login = this.user.login
      this.role = this.user.role
      this.inactivated = this.user.inactivated
    },

    validPassword () {
      if (this.editing) {
        return this.validateEditPassword()
      }
      return this.canChangePassword()
    },

    validateEditPassword () {
      if (this.password.trim().lenght === 0) {
        return true
      }
      return this.canChangePassword()
    },
    canChangePassword () {
      let hasNewPass = this.password && this.password.length > 0
      let hasConfirmNewPass = this.confirmPassword && this.confirmPassword.length > 0
      let equalNewPass = this.password === this.confirmPassword
      return hasNewPass && hasConfirmNewPass && equalNewPass
    }
  },

  mounted () {
    this.resetOne()
    if (this.id) {
      this.fetchOne(this.id)
        .then(() => {
          this.setOldValues()
          this.roleValue = this.user.role
        })
    }
    this.roleValue = this.user.role
    this.getRoles()
    this.setOptions()
  },

  watch: {
    model () {
      this.getRoles()
    },
    roles () {
      this.setOptions()
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Users/UsersForm.vue